
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 38 38"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"data-name":"Ellipse 300","cx":"18.999","cy":"18.999","r":"18.999","fill":"none"}}),_c('g',{attrs:{"data-name":"linkedin"}},[_c('path',{attrs:{"data-name":"Path 75","d":"M31.111 19.362v8.377h-4.858V19.92c0-1.963-.7-3.3-2.46-3.3a2.656 2.656 0 00-2.491 1.776 3.324 3.324 0 00-.161 1.184v8.158h-4.854s.065-13.236 0-14.608h4.858v2.073l-.033.048h.033v-.048a4.822 4.822 0 014.377-2.412c3.2 0 5.59 2.087 5.59 6.574zM11.199 6.087a2.53 2.53 0 10-.058 5.056h.031a2.531 2.531 0 10.033-5.049zM8.745 27.739h4.854V13.131H8.745z","fill":"#fff"}})])])
          )
        }
      }
    